"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./attribution.component"));
__export(require("./control.component"));
__export(require("./default.component"));
__export(require("./fullscreen.component"));
__export(require("./mouseposition.component"));
__export(require("./overviewmap.component"));
__export(require("./rotate.component"));
__export(require("./scaleline.component"));
__export(require("./zoom.component"));
__export(require("./zoomslider.component"));
__export(require("./zoomtoextent.component"));
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-openlayers/dist/components/controls/index.js
// module id = 1061
// module chunks = 3